export default (incomeSourceConfigurationId = null) => ({
    id: null,
    incomeSourceConfigurationId,
    enteredIncomeSource: '',
    monthlyIncome: null
});